import type { InvoiceDocument } from '../../../types/invoice-document'
import { buildInvoiceDocument } from '../../../types/invoice-document'

const normalizeInvoiceDocument = function (input: Object): InvoiceDocument {
  return {
    ...buildInvoiceDocument(),
    fileType: input.fileType,
    identifier: input.identifier,
    isAvailable: input.isAvailable,
    role: input.role
  }
}

export {
  normalizeInvoiceDocument
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/invoice-document-normalizer.js